import { styled, TableCell } from "@mui/material";

const StyledTableCell = styled(TableCell)({
  height: "40px",
  padding: "0px 12px",
  borderBottomColor: "#fff",
  maxWidth: 140,
});

export default StyledTableCell;
